import { SecondaryCode } from "@fusion-advantage/backcompat"

export enum ContraStatus {
	// this code has no conflict—
	// ok to submit
	NoConflict = 'NoConflict',
	// automatically removed code—
	// the code was removed by dan's procedure because it substituted in
	// one or more codes that were a better fit;
	// ok to submit
	Victim = 'ContraVictim',
	// this code cannot be submitted—
	// the string value of .Contra here denotes the other ICD code it
	// conflicts with; some change must be made to the accepted codes in the
	// diagnosis review before the encounter can be finalized
	Conflict = 'Conflict',
}

export const contraStatus = (model: SecondaryCode): ContraStatus => {
	if(!model.Contra) {
		return ContraStatus.NoConflict
	} else if(model.Contra === 'ContraVictim') {
		return ContraStatus.Victim
	} else {
		return ContraStatus.Conflict
	}
}

export const secondaryCodeCompare = (a: SecondaryCode, b: SecondaryCode): number => {
	const aStat = contraStatus(a)
	const bStat = contraStatus(b)
	if(aStat === bStat) return 0
	// no conflict first
	if(aStat === ContraStatus.NoConflict) return -1
	if(bStat === ContraStatus.NoConflict) return 1
	// then victims
	if(aStat === ContraStatus.Victim) return -1
	if(bStat === ContraStatus.Victim) return 1
	// then alphabetical conflicting ICD codes
	// (these should not be empty due contraStatus logic above)
	return (a.Contra ?? '').localeCompare(b.Contra ?? '')
}
